import React from 'react';
import CustomScrollbars from 'util/CustomScrollbars';
import Moment from 'moment';

const Notifications = ({ notifications, toReport }) => {
	return (
		<CustomScrollbars className="messages-list scrollbar" style={{ height: 280 }}>
			<ul className="list-unstyled">
				{notifications.length > 0 ? (
					notifications.map((notification, index) => (
						<li className="media pt-2 pointer" onClick={() => toReport(notification.reference)} key={index}>
							<div className="media-body align-self-center">
								<p className="mb-0">{notification.title}</p>
								<p className="sub-heading mb-0">{notification.message}</p>
								<span className="meta-date">
									<small>{Moment(notification.date).format('DD.MM.YYYY HH:mm')}</small>
								</span>
							</div>
						</li>
					))
				) : (
					<li className="w-100">
						<div className="media-body">
							<div className="d-flex justify-content-center align-items-center">
								<h5 className="text-muted">Keine Benachrichtigungen vorhanden</h5>
							</div>
						</div>
					</li>
				)}
			</ul>
		</CustomScrollbars>
	);
};

export default Notifications;



// WEBPACK FOOTER //
// ./containers/Header/Notifications.js